import 'twin.macro';
import React from 'react';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { getHolidaysWithinInterval } from '@teetsh/app/src/utils/time/getHolidaysWithinInterval';

interface Props {
  day: Date;
  className?: string;
}

export function AnnualEvents(props: Props) {
  const { day, className } = props;
  const { schoolyear } = useSchoolSchoolyear();
  return (
    <>
      {getHolidaysWithinInterval(
        day,
        day,
        schoolyear?.zone?.holidays || [],
      ).map(h => (
        <div
          key={h.id}
          className={className}
          tw="rounded-lg text-center p-2 bg-brand-moderate text-brand-intense font-semibold"
        >
          {h.label}
        </div>
      ))}
    </>
  );
}
